export default "__VITE_ASSET__Czwrm9dt__"